module.exports = __webpack_public_path__ + "media/my_images/vision/meetan-2e1f96e1b15da1c1af3849cd6889df1b.png";